export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-shrink-0">
            <div className="relative w-48 h-48 md:w-56 md:h-56 rounded-3xl overflow-hidden border-2 border-background-200/60">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20minimalist%20mobile%20phone%20app%20interface%20mockup%20with%20warm%20amber%20and%20crimson%20accents%2C%20premium%20app%20icon%20design%2C%20dark%20elegant%20background%2C%20video%20play%20button%20motif%2C%20sleek%20modern%20UI%20design%2C%20entertainment%20app%20aesthetic%2C%20no%20text&width=560&height=560&seq=app-mockup-91hlw&orientation=squarish"
                alt="91黑料网移动端APP"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-black text-foreground-900 mb-3">移动端随时观看</h2>
            <p className="text-foreground-500 text-sm leading-relaxed mb-6">
              91黑料网已推出专属移动端应用，支持随时随地流畅观看最新黑料短视频。无论您身在何处，
              打开手机即可获取每日更新的黑料视频合集，不错过任何精彩爆料。应用界面简洁流畅，
              播放体验出色，让黑料视频在线观看更加便捷。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#contact"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer no-underline text-sm"
              >
                <i className="ri-smartphone-line text-lg" />
                获取移动端入口
              </a>
              <a
                href="#features"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-200/70 hover:bg-background-300/70 text-foreground-700 font-medium rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer no-underline text-sm"
              >
                <i className="ri-information-line text-lg" />
                了解更多功能
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}